import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlReportSecured,
  urlReportAllSecured,
  urlreportFilterAll,
  urlReportOneSecured,
  urlSkillsSecured,
} from "../../api/urls";

import { PAGE_SIZE_10 } from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.uuid !== undefined) filter += "&uuid=" + filters.uuid;
    if (filters.year !== undefined) filter += "&year=" + filters.year;
    if (filters.department !== undefined)
      filter += "&department=" + filters.department;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

const generateFilterAllQuery = (filters) => {
  let filter = "?";

  if (filters) {
    if (filters.year !== undefined) filter += "&year=" + filters.year;
    if (filters.department !== undefined)
      filter += "&department=" + filters.department;
  }

  return filter;
};

/**
 * Get Report by uuid.
 */
export const getReportByUuid = createAction("GET_REPORT", (param) =>
  apiGet(urlReportSecured, param, true)()
);

/**
 * Filter list Report.
 */
export const filterReport = createAction("FILTER_REPORT", (filter, param) =>
  apiGet(urlReportSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create Report.
 */
export const createReport = createAction("CREATE_REPORT", (obj) =>
  apiPost(urlReportSecured, obj, undefined, true)()
);

/**
 * Update Report.
 */
export const modifyReport = createAction("UPDATE_REPORT", (obj, param) =>
  apiPut(urlReportSecured, obj, param, true)()
);

/**
 * Delete Report by uuid.
 */
export const removeReport = createAction("DELETE_REPORT", (param) =>
  apiDelete(urlReportSecured, param, true)()
);

/**
 * Filter list Report.
 */
// export const filterAllReport = createAction("FILTER_ALL_REPORT", (filter) =>
//   apiGet(urlReportAllSecured + generateFilterQuery(filter), undefined, true)()
// );

export const filterAllReport = createAction(
  "FILTER_ALL_REPORT",
  (filter, param) =>
    apiGet(urlReportAllSecured + generateFilterAllQuery(filter), param, false)()
);

export const filterOne = createAction("FILTER_ONE_REPORT", (filter, param) =>
  apiGet(urlReportOneSecured + generateFilterAllQuery(filter), param, false)()
);

export const allSkills = createAction("ALL_SKILLS", () =>
  apiGet(urlSkillsSecured, undefined, undefined, true)()
);
